'use strict';

/**
 * Site banner.
 *
 * Publishes the banner's bottom edge (relative to the viewport) as
 * `--site-banner-bottom` on the root element so the fixed site header can sit
 * directly beneath it, whether the banner is sticky (md and up) or scrolling
 * away with the page (mobile). Also handles optional dismissal, remembered per
 * banner ID in localStorage.
 */
document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'siteBanner', ( id, dismissible = false ) => ({

		dismissed : false,
		rafId     : null,
		storageKey: `umaritime-site-banner-dismissed-${id}`,

		init() {
			if ( dismissible ) {
				try {
					this.dismissed = '1' === window.localStorage.getItem( this.storageKey );
				} catch ( e ) {
					this.dismissed = false;
				}
			}

			const onScroll = () => {
				if ( this.rafId ) {
					return;
				}

				this.rafId = requestAnimationFrame( () => {
					this.rafId = null;
					this.update();
				});
			};

			this.$watch( 'dismissed', () => this.$nextTick( () => this.update() ) );

			new ResizeObserver( () => this.update() ).observe( this.$el );
			window.addEventListener( 'scroll', onScroll, { passive: true });
			window.addEventListener( 'resize', onScroll, { passive: true });

			this.update();
		},

		update() {
			const root = document.documentElement;

			if ( this.dismissed ) {
				root.style.removeProperty( '--site-banner-bottom' );
				return;
			}

			const bottom = Math.max( 0, this.$el.getBoundingClientRect().bottom );
			root.style.setProperty( '--site-banner-bottom', `${bottom}px` );
		},

		dismiss() {
			this.dismissed = true;

			try {
				window.localStorage.setItem( this.storageKey, '1' );
			} catch ( e ) {
				// Storage unavailable; the banner stays hidden for this page view only.
			}
		},
	}) );
});
